import { logger } from '@libs/core';

import { ERROR_PRESET, showError } from '@/shared/notifications';

export const useOnError = () => {
    const onError = (error?: Error) => {
        logger.error('[ADD TO CART][Error]: %o', error);
        showError(ERROR_PRESET.unexpected);
    };

    return { onError };
};
